/**
 * Copyright (c) 2022 by 安徽网才信息技术股份有限公司
 *
 * 除非事先获得版权所有人的许可, 禁止以下几项行为:
 * 1. 对该软件的任何源代码和技术文档进行任意形式的打包、分发或复制用于其他目的。
 * 2. 向第三方透露任何与该软件相关的源代码或技术文档。
 * 3. 更改或删除软件或源码中的版权声明。
 */

import axios from 'axios';
import {throttle} from 'lodash';
import {Message, Loading} from 'element-ui';
import router from '@/router';
import store from '@/store';

class HttpRequest {
    constructor(baseUrl)
    {
        this.baseUrl = baseUrl;

        this.globalErrorHandlers = {
            'status:404': throttle(this.handleError404, 2000, {leading: true}),
            'status:500': throttle(this.handleError500, 2000, {leading: true})
        };
    }

    getInsideConfig()
    {
        return {
            baseURL: this.baseUrl,
            timeout: 30000,
            withCredentials: true,
            headers: {
                'X-Agent': store.state.agent
            }
        };
    }

    interceptors(instance, options)
    {
        const initToken = sessionStorage.getItem('X-Session-Token');
        if (initToken) {
            options.headers = options.headers || {};
            options.headers['X-Session-Token'] = initToken;
        }
    }

    request(options)
    {
        const instance = axios.create();
        options = {...this.getInsideConfig(), ...options};
        this.interceptors(instance, options);

        return new Promise((resolve, reject) => {
            instance(options).then((resp) => {
                const {
                    status,
                    data
                } = resp;

                if (this.globalErrorHandlers[`status:${status}`]) {
                    this.globalErrorHandlers[`status:${status}`](options, resp, {
                        resolve,
                        reject
                    });
                    return;
                }

                if (data.code && data.code !== 20002) {
                    if (data.code === 70401) {
                        Message.error(data.code === 70401 ? '请先登录' : data.errorMessage.message);
                        store.dispatch('handleLogout');
                        router.replace({
                            name: 'login',
                            query: {redirect: router.currentRoute.fullPath}
                        });
                    } else if (data.code === 70403) {
                        store.dispatch('handleLogout');
                        sessionStorage.clear();
                        if (['user-center', 'user-set', 'apply'].includes(router.currentRoute.name)) {
                            router.replace({
                                name: 'login',
                                query: {redirect: router.currentRoute.fullPath}
                            });
                        }
                    } else if (data.code === 70404) {
                        router.replace({name: 'error_404'});
                    } else if (data.code === 20011) {
                        router.replace({name: 'project'});
                    } else {
                        Message.error(data.errorMessage.message);
                    }
                    Loading.service({}).close();
                    return;
                }
                resolve(data);
            }).catch((error) => {
                let errorInfo = error.response;
                if (!errorInfo) {
                    const { request: { statusText, status }, config } = JSON.parse(JSON.stringify(error));
                    errorInfo = {
                        statusText,
                        status,
                        request: { responseURL: config.url }
                    };
                }
                reject(errorInfo);
            });
        });
    }

    handleError404(options, resp, {reject})
    {
        console.trace('error-404');

        reject(resp);
    }

    handleError500(options, resp, {reject})
    {
        console.trace('error-500');

        reject(resp);
    }
}

export default HttpRequest;
